/**
 * A layer over the page that closes on Back (the 13 Shorts player) adds a
 * history entry of its own; the step back from it to the page's own entry is
 * the layer's, not a navigation. NavigationProvider's beforePopState (the one
 * callback Next allows) asks here first and keeps Next's router out of it.
 */
type PopStateHold = (key: string | undefined) => boolean

const holds = new Set<PopStateHold>()

/** `owns(key)` says a step back to the entry `key` is the layer's; returns its release */
export const holdPopState = (owns: PopStateHold) => {
  holds.add(owns)
  return () => {
    holds.delete(owns)
  }
}

/** a step back to the entry `key` belongs to a layer: Next leaves it alone */
export const popStateHeld = (key: string | undefined) =>
  Array.from(holds).some(owns => owns(key))
